import React, { useEffect, useState } from "react";
import "./About.css";
import axios from "axios";
import { useAppContext } from "../../contexts/AppContext";
import parse from "html-react-parser";
import { NavLink } from "react-router-dom";

function AboutUs() {
  const [aboutInformation, setAboutInformation] = useState([]);
  const {
    backendUrl,
    translate,
    getImageUrl,
    updateFullData,
    updateSelectedData,
    updateSelectedTitle,
  } = useAppContext();
  const [About, setAbout] = useState([]);
  const route = "/About";
  const aboutListRoute = "/AboutList";
  const companyRoute = "/company";
  
  const myIcon = {
    VISION: "bi-binoculars",
    MISSION: "bi-rocket",
    VALUES: "bi-lightbulb",
    GOALS: "bi-lightbulb",
  };

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const response = await axios.get(`${backendUrl}${route}`);
        if (Array.isArray(response?.data) && response?.data?.length > 0) {
          setAboutInformation(response?.data);
        }

        const aboutResponse = await axios.get(`${backendUrl}${aboutListRoute}`);
        if (Array.isArray(aboutResponse?.data) && aboutResponse?.data?.length > 0) {
          setAbout(aboutResponse?.data);
        }

        await axios.get(`${backendUrl}${companyRoute}`);
      } catch (error) {
        console.error("Error fetching about content:", error);
      }
    };
    fetchAbout();
  }, [backendUrl]);

  return (
    <section id="about-us" className="about-section">
      {Array.isArray(aboutInformation) && aboutInformation.length > 0 && (
        <div className="container py-5">
          {aboutInformation.map((aboutInfo, index) => (
            <div key={index} className="about-body-section text-center mb-5 animated">
              <h1 className="about-main-title">{parse(translate(aboutInfo?.title))}</h1>
              <div className="about-title-separator"></div>
              <div className="about-main-description mt-4">
                {parse(translate(aboutInfo.content))}
              </div>
            </div>
          ))}

          <div className="about-list-grid mt-5">
            <div className="row g-4 justify-content-center">
              {Array.isArray(About) && About.length > 0 &&
                About.map((aboutItem) => (
                  <div key={aboutItem?.id} className="col-lg-4 col-md-6">
                    <div className="about-card shadow-sm h-100">
                      <div className="about-card-icon-container mb-3">
                        {myIcon[aboutItem?.title?.toUpperCase()] ? (
                          <i className={`bi ${myIcon[aboutItem?.title?.toUpperCase()]}`}></i>
                        ) : (
                          aboutItem?.images?.length > 0 ? (
                            <img
                              src={getImageUrl(aboutItem?.images[0])}
                              alt={aboutItem?.title}
                              className="about-card-img"
                            />
                          ) : (
                            <i className="bi bi-info-circle-fill"></i>
                          )
                        )}
                      </div>
                      <h3 className="about-card-title">{parse(translate(aboutItem?.title))}</h3>
                      <div className="about-card-content">
                        {parse(translate(aboutItem?.content))}
                      </div>
                      <NavLink
                        to={`/about/${aboutItem.id}`}
                        className="about-read-more-btn mt-3"
                        onClick={() => {
                          updateFullData(About);
                          updateSelectedData(aboutItem);
                          updateSelectedTitle("About");
                        }}
                      >
                        {translate("Read More")} <i className="bi bi-arrow-right ms-2"></i>
                      </NavLink>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default AboutUs;
